import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Box from '@material-ui/core/Box';
import { handleMenuItemClick } from 'bento-ordering/menus/actions';
import { setScrollPosition } from 'bento-ordering/base/actions/scrollManager';
import { slugify } from 'bento-ordering/utils/slugify';

import { MENU } from 'bento-ordering/menus/constants/entities';

import MenuSectionHeader from 'bento-ordering/menus/components/MenuSectionHeader';
import MenuSectionList from 'bento-ordering/menus/components/MenuSectionList';

class MenuSection extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    items: PropTypes.array,
    dispatch: PropTypes.func.isRequired,
    isLast: PropTypes.bool.isRequired,
    isFirst: PropTypes.bool.isRequired,
    shouldLazyLoadMenu: PropTypes.bool
  };

  static defaultProps = {
    accordionUsesHandleClick: false
  };

  state = {
    isExpanded: true
  };

  handleClick = slug => {
    const { dispatch } = this.props;
    dispatch(setScrollPosition(MENU, window.pageYOffset));
    return dispatch(handleMenuItemClick(slug));
  };

  toggleExpand = () => {
    this.setState({ isExpanded: !this.state.isExpanded });
  };

  handleAccordionClick = () => {
    const isExpired = this.handleClick();
    if (!isExpired) {
      this.toggleExpand();
    }
  };

  getSectionMargin = () => {
    let marginBottom = 1;

    if (this.props.isLast || !this.state.isExpanded) {
      marginBottom = 0;
    }
    return marginBottom;
  };

  render() {
    const { name, items, shouldLazyLoadMenu, isFirst } = this.props;
    const { isExpanded } = this.state;
    const marginTop = this.getSectionMargin();
    return (
      <Box id={slugify(name)} mb={marginTop}>
        <MenuSectionHeader isFirst={isFirst} title={name} />
        <MenuSectionList
          menuList={items}
          isExpanded={isExpanded}
          handleClick={this.handleClick}
          shouldLazyLoadMenu={shouldLazyLoadMenu}
        />
      </Box>
    );
  }
}

export default connect()(MenuSection);
